import {
  SelectedVariantAddToCartButton,
  useCart,
  useProduct,
} from "@shopify/hydrogen/client";
import compact from "lodash/compact";
import { useRouter } from "next/router";
import { useEffect } from "react";

import { useCartUI } from "../../hooks/use-cart-ui";
import { usePrevious } from "../../hooks/use-previous";
import { BUTTON_PRIMARY_CLASSES } from "../cart/CartIconWithItemsButton";

export function SelectedVariantButtons() {
  const router = useRouter();

  const { toggleCart, closeItemModal, isCurrentOptionAvailable } = useCartUI();

  const lookbookId = router.query?.slug?.[0];
  const { message_id: messageId } = router.query;

  const product = useProduct();

  const { status, lines } = useCart();

  const isOutOfStock = !product?.selectedVariant?.availableForSale;

  const prevStatus = usePrevious(status);
  useEffect(() => {
    if (status === "idle" && prevStatus === "updating" && lines.length > 0) {
      toggleCart();
    }
  }, [status, prevStatus, lines.length, closeItemModal, toggleCart]);

  if (!isCurrentOptionAvailable) {
    return (
      <button
        type="button"
        className={BUTTON_PRIMARY_CLASSES}
        disabled={true}
        data-test-id="no-option-available-button">
        {"Not Available"}
      </button>
    );
  }

  return (
    <>
      {/** @note Because no disabled prop in <SelectedVariantAddToCartButton/> */}
      {isOutOfStock ? (
        <button
          type="button"
          className={BUTTON_PRIMARY_CLASSES}
          disabled={true}
          data-test-id="out-of-stock-add-to-cart-button">
          Out of Stock
        </button>
      ) : (
        <SelectedVariantAddToCartButton
          type="button"
          className={BUTTON_PRIMARY_CLASSES}
          data-test-id="selected-variant-add-to-bag-button"
          attributes={compact([
            typeof lookbookId === "string" && lookbookId.length
              ? { key: "lookbookId", value: lookbookId }
              : null,
            typeof messageId === "string" && messageId.length
              ? { key: "messageId", value: messageId }
              : null,
          ])}>
          {status === "updating" ? "Adding..." : "Add to Bag"}
        </SelectedVariantAddToCartButton>
      )}
    </>
  );
}
